import type { WorkspaceNavigationLabel } from "./workspace-navigation-shell";
import { flowCoverColor } from "@/lib/flow-cover-key";

/** Display-only list metadata. Never selects the active shop or authorizes an
 * editor. An unpinned/missing shop waits for activation instead of borrowing
 * the previous route's scope. No coverage or image is inferred from this card. */
export function workspaceHeaderPreview(label: WorkspaceNavigationLabel | null | undefined, stores: readonly { id: string; name: string }[]) {
  const ref = label?.store_ref;
  const name = ref === "all" ? "Все магазины" : ref ? stores.find(store => store.id === ref)?.name : undefined;
  const previewReady = label?.description !== undefined && label.updated_at !== undefined;
  return {
    pageId: label?.id ?? "", title: label?.title || "Страница", icon: label?.icon ?? "📦",
    ...(flowCoverColor(label?.coverColor) ? { cover: label!.coverColor } : {}),
    description: label?.description ?? "", changedAt: Date.parse(label?.updated_at ?? "") || undefined,
    storeChip: name ? { name, pinned: true } : null,
    storePending: stores.length > 1 && !name,
    previewReady, canEdit: false, pending: true,
  };
}
